import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../../styles/utils';
import { HorizontalLine } from '../../common/HorizontalLine';
import * as constants from '../../../constants/SwitchTransaction';
import { P2, B2 , ReadMore} from 'pfm-ui-components';
import { up } from 'styled-breakpoints';
import { useRouter } from 'next/router';
import { useDeviceType } from '../../../utils/deviceType';
import DEVICE_TYPE from '../../../constants/device';

interface NotePointsProps {
  notData: Array<string>;
  isAxisSelect?: boolean;
  showRegulatoryNote?: boolean;
  handleClickHere?: Function;
}
export default function NotePoints(props: NotePointsProps) {
  const { notData, isAxisSelect, handleClickHere,showRegulatoryNote } = props;
  const router = useRouter();
  const handleKFintechClick =()=>{
    window.open(`https://mfs.kfintech.com/investor/General/NCTNomineeUpdation`, '_blank')
  }
  const handleCAMSClick =()=>{
    window.open(`https://digital.camsonline.com/changeofnomination`, '_blank')
  }
  const [isTransactPage, setIsTransactPage] = useState(false);
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  const NoteData = notData?.map((item, key) => {
    return (
      <StyledLI key={key}>
        <StyledP2>{item}</StyledP2>
      </StyledLI>
    );
  });

  useEffect(() => {
    if (router) {
      setIsTransactPage(router.pathname.includes('/transact/'));
    }
  }, [router.query]);
  return (
    <Wrapper>
      <HorizontalLine />
      <NoteWrapper>
        <CaptionWrapper>
          <StyledB2>{NoteData?.length > 1 ? 'Notes' : 'Note'}</StyledB2>
        </CaptionWrapper>
        {isTransactPage && isMobile ? (
        <ReadMore less="Read Less" more="Read More" lines={2}>
          <StyledUL>{NoteData}</StyledUL>
          {showRegulatoryNote && (
          <StyledULSelect>
            <StyledLI>
              <StyledP2>
              To view / update your existing Mutual Fund folios nomination, visit
                <TextHighlight2 onClick={() => handleKFintechClick()}> KFintech </TextHighlight2>
                or
                <TextHighlight2 onClick={() => handleCAMSClick()}> CAMS </TextHighlight2>
                website
              </StyledP2>
            </StyledLI>
          </StyledULSelect>
        )}
        </ReadMore>
      ) : (
        <>
        <StyledUL>{NoteData}</StyledUL>
        {showRegulatoryNote && (
          <StyledULSelect>
            <StyledLI>
              <StyledP2>
              To view / update your existing Mutual Fund folios nomination, visit
                <TextHighlight2 onClick={() => handleKFintechClick()}> KFintech </TextHighlight2>
                or
                <TextHighlight2 onClick={() => handleCAMSClick()}> CAMS </TextHighlight2>
                website
              </StyledP2>
            </StyledLI>
          </StyledULSelect>
        )}
        </>
      )}
        {isAxisSelect && (
          <StyledULSelect>
            <StyledLI>
              <StyledP2>
                To view the disclaimer for Axis Select Funds, Please
                <TextHighlight onClick={() => handleClickHere()}> Click Here </TextHighlight>
              </StyledP2>
            </StyledLI>
          </StyledULSelect>
        )}
        
      </NoteWrapper>
      <HorizontalLine />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-top: ${pxToRem(16)};
  ${up('md')} {
    margin-top: ${pxToRem(24)};
  }
`;
const NoteWrapper = styled.div`
  padding-bottom: ${pxToRem(12)};
  ${up('md')} {
    display: block;
  }
`;

const CaptionWrapper = styled.div`
  margin-right: ${pxToRem(12)};
  padding-top: ${pxToRem(16)};
  ${up('md')} {
    padding-top: ${pxToRem(12)};
  }
`;

const StyledUL = styled.ul`
  padding-left: ${pxToRem(20)};
  padding-right: ${pxToRem(8)};
  margin-top: ${pxToRem(8)};
  margin-bottom: 0;
  color: ${(props) => props.theme.palette.grey3};
`;
const StyledULSelect = styled.ul`
  padding-left: ${pxToRem(20)};
  padding-right: ${pxToRem(8)};
  margin-top:0;
  margin-bottom: 0;
  color: ${(props) => props.theme.palette.grey3};
`;

const StyledLI = styled.li`
  padding-bottom: ${pxToRem(8)};
`;

const StyledP2 = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
  font-style: italic;
`;

const StyledB2 = styled(B2)`
  color: ${(props) => props.theme.palette.grey2};
`;

const TextHighlight = styled.span`
  color: ${(props) => props.theme.palette.burgundy1};
  cursor: pointer;
`;
const TextHighlight2 = styled.span`
  text-decoration:underline;
  color: ${(props) => props.theme.palette.burgundy1};
  cursor: pointer;
`;
